import React from 'react';

import { ReactComponent as AccelerometerIcon } from '../../asset/icon/AccelerometerIcon.svg';
import { ReactComponent as AvatarIcon } from '../../asset/icon/AvatarIcon.svg';
import { ReactComponent as AvatarLargerIcon } from '../../asset/icon/AvatarLargerIcon.svg';
import { ReactComponent as ClockIcon } from '../../asset/icon/ClockIcon.svg';
import { ReactComponent as GlobeIcon } from '../../asset/icon/GlobeIcon.svg';
import { ReactComponent as GearIcon } from '../../asset/icon/GearIcon.svg';
import { ReactComponent as HomeIcon } from '../../asset/icon/HomeIcon.svg';
import { ReactComponent as InvoiceIcon } from '../../asset/icon/InvoiceIcon.svg';
import { ReactComponent as NodeIcon } from '../../asset/icon/NodeIcon.svg';
import { ReactComponent as NetworkIcon } from '../../asset/icon/NetworkIcon.svg';
import { ReactComponent as PhoneIcon } from '../../asset/icon/PhoneIcon.svg';
import { ReactComponent as ReloadIcon } from '../../asset/icon/ReloadIcon.svg';

export type IconType =
  | 'avatar'
  | 'gear'
  | 'network'
  | 'home'
  | 'clock'
  | 'avatarLarger'
  | 'reload'
  | 'globe'
  | 'node'
  | 'accelerometer'
  | 'invoice'
  | 'phone';

export interface IconProps
  extends Readonly<{
    type: IconType;
  }> {}

export const Icon = React.memo<IconProps>((props) => {
  const { type } = props;

  switch (type) {
    case 'avatar':
      return <AvatarIcon />;
    case 'gear':
      return <GearIcon />;
    case 'network':
      return <NetworkIcon />;
    case 'home':
      return <HomeIcon />;
    case 'clock':
      return <ClockIcon />;
    case 'avatarLarger':
      return <AvatarLargerIcon />;
    case 'reload':
      return <ReloadIcon />;
    case 'globe':
      return <GlobeIcon />;
    case 'node':
      return <NodeIcon />;
    case 'accelerometer':
      return <AccelerometerIcon />;
    case 'invoice':
      return <InvoiceIcon />;
    case 'phone':
      return <PhoneIcon />;
    default:
      throw new Error('Icon: unknown icon type!');
  }
});
